import script from "./IpGeoMap.vue?vue&type=script&setup=true&lang=js"
export * from "./IpGeoMap.vue?vue&type=script&setup=true&lang=js"

import "./IpGeoMap.vue?vue&type=style&index=0&id=979e55f2&scoped=true&lang=css"
import "./IpGeoMap.vue?vue&type=style&index=1&id=979e55f2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-979e55f2"]])

export default __exports__